import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import { MyQBRDropdown } from './filters/MyQBRsFilter'
import { OnlyLegacyCheckbox } from './filters/OnlyLegacyCheckbox'
import { QBRCreatorsFilter } from './filters/QbrCreatorsFilter'
import { QBRsFYearMultiselect } from './filters/QbrFYearFilter'
import { QBRGeoFilter } from './filters/QbrGeoFilter'
import { QBRPartnerFilter } from './filters/QbrPartnersFilter'

import styles from './QBRDocumentsFilterArea.module.scss'

export interface IQBRFilterAreaProps {
  qbrDocumentsData: IQBRDocumentsListItem[]
  myQbrValue: boolean
  onChangeMyQbrFilter: (value: boolean) => void
  fyearValue: string[]
  onChangeFyearValue: (value: string[]) => void
  geoValue: string[]
  onChangeGeoValue: (value: string[]) => void
  creatorsValue: string[]
  onChangeCreatorsValue: (value: string[]) => void
  partnersValue: string[]
  onChangePartnersValue: (value: string[]) => void
  isOnlyLegacy: boolean
  onChangeIsOnlyLegacy: (value: boolean) => void
  onApplyFilter: () => void
  onResetFilter: () => void
}

export const QBRDocumentsFilterArea = ({
  qbrDocumentsData,
  myQbrValue,
  onChangeMyQbrFilter,
  fyearValue,
  onChangeFyearValue,
  geoValue,
  onChangeGeoValue,
  creatorsValue,
  onChangeCreatorsValue,
  partnersValue,
  onChangePartnersValue,
  isOnlyLegacy,
  onChangeIsOnlyLegacy,
  onApplyFilter,
  onResetFilter,
}: IQBRFilterAreaProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.filterFields}>
        <div className={styles.qbrCheckbox}>
          <MyQBRDropdown qbrValue={myQbrValue} onChangeQbrFilter={onChangeMyQbrFilter} />
        </div>
        <div className={styles.qbrCheckbox}>
          <OnlyLegacyCheckbox
            isOnlyLegacy={isOnlyLegacy}
            onChangeIsOnlyLegacy={onChangeIsOnlyLegacy}
          />
        </div>
        <div className={styles.input}>
          <QBRsFYearMultiselect
            fyearValue={fyearValue}
            onChangeFyearValue={onChangeFyearValue}
            qbrDocumentsData={qbrDocumentsData}
          />
        </div>
        <div className={styles.input}>
          <QBRGeoFilter
            qbrDocumentsData={qbrDocumentsData}
            geoValue={geoValue}
            onChangeGeoValue={onChangeGeoValue}
          />
        </div>
        <div className={styles.input}>
          <QBRCreatorsFilter
            qbrDocumentsData={qbrDocumentsData}
            creatorsValue={creatorsValue}
            onChangeCreatorsValue={onChangeCreatorsValue}
          />
        </div>
        <div className={styles.input}>
          <QBRPartnerFilter
            qbrDocumentsData={qbrDocumentsData}
            partnersValue={partnersValue}
            onChangePartnersValue={onChangePartnersValue}
          />
        </div>
      </div>

      <div className={styles.filterBtns}>
        <Button onClick={onApplyFilter}>
          <Translation text={TRANSLATION_KEYS.tableFilters.applyFilters} />
        </Button>
        <Button onClick={onResetFilter} color={'danger'}>
          <Translation text={TRANSLATION_KEYS.tableFilters.clearFilters} />
        </Button>
      </div>
    </div>
  )
}
